import { JSX } from "preact";

export function GTLogo(props: JSX.ImgHTMLAttributes & { light: true }) {
  return <img src={`/img/logos/ignitebackground-${props.light ? 'light' : 'dark'}.svg`} width={70} height={70} {...props} />;
}